import { directusApi, PaginatedCollection } from '@/api';
import { Data } from '@/models/data.model';
import { asyncForEach, formatNested, validateFileName } from '@/utils';
import lodash from 'lodash';
import axios from 'axios';
const data = new FormData();

export interface ChatbotDocument {
    id?: number;
    assistant_name: string;
    document?: any;
    sku_document?: any;
    new_sku: string;
}

export interface ChatbotDocumentState {
    allChatbotDocuments: Array<ChatbotDocument>;
    allChatbotDocumentsLoading: boolean;
    chatbotDocumentsPerPage: number;
    chatbotDocumentsPage: number;
    chatbotDocumentsTotal: number;
    activeChatbotDocument: ChatbotDocument | null;
    activeChatbotDocumentLoading: boolean;
}

const defaultChatbotDocument = {
    id: 0,
    assistant_name: '',
    document: null,
    sku_document: [],
    new_sku: '',
};

const state: ChatbotDocumentState = {
    allChatbotDocuments: [],
    allChatbotDocumentsLoading: false,
    chatbotDocumentsPerPage: 1,
    chatbotDocumentsPage: 1,
    chatbotDocumentsTotal: 1,

    activeChatbotDocument: {
        id: 0,
        assistant_name: '',
        document: [],
        sku_document: [],
        new_sku: '',
    },
    activeChatbotDocumentLoading: false,
};

const mutations = {
    TOGGLE_ALL_CHATBOTS_LOADING(state: ChatbotDocumentState, data: boolean) {
        state.allChatbotDocumentsLoading = data;
    },
    SET_ALL_CHATBOTS(state: ChatbotDocumentState, data: PaginatedCollection) {
        state.allChatbotDocuments = data.items;
        state.chatbotDocumentsPerPage = data.perPage;
        state.chatbotDocumentsPage = data.currentPage;
        state.chatbotDocumentsTotal = data.totalItems;
    },
    TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING(state: ChatbotDocumentState, data: boolean) {
        state.activeChatbotDocumentLoading = data;
    },
    REMOVE_CHATBOT_DOCUMENT(state: ChatbotDocumentState, id: number) {
        state.allChatbotDocuments = lodash.remove(state.allChatbotDocuments, function(n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_CHATBOT_DOCUMENT(state: ChatbotDocumentState, data: ChatbotDocument) {
        let document = data.document ? { id: data.document, url: `https://directus.prodelec.app/assets/${data.document}`, origin: 'directus' } : null;
        state.activeChatbotDocument = {
            ...data,
            document,
        };
    },
};

const actions = {
  /*############################
    # Ver Todos los asistentes #
    ############################*/
    async getAll({ _, commit }: any, { search, page }: any) {
        let params = '';
        let limit = 8;

        if (search) params += `&filter[title][_contains]=${search}`;
        params += `&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=${limit}&offset=${(page - 1) * limit}`;

        // if (sortName) params = { ...params, sortName };
        // if (sortValue) params = { ...params, sortValue };
        // if (filterStatus) params = { ...params, search: filterStatus };
        // params += &limit=${limit}&meta=total_count&sort=assistant_name;

        let query = `items/ai_assistants?${params}`;

        await directusApi('GET', query)
            .then(res => {
                commit('SET_ALL_CHATBOTS', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.total_count,
                });
            })
            // .then(res => {
            //     commit('SET_ALL_CHATBOTS', res.data.data);
            // })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_CHATBOTS_LOADING', false);
            });
    },

  /*#####################
    # Ver un asistentes #
    #####################*/
    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', true);
        let datos
        if (id) {
            await directusApi('GET', `items/ai_assistants/${id}`)
                .then(res => {
                    commit('SET_ACTIVE_CHATBOT_DOCUMENT', res.data.data);
                    console.log(res.data.data);
                    datos = res.data.data
                    return res.data.data;
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_CHATBOT_DOCUMENT', defaultChatbotDocument);
            commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
        }
        return datos;
    },

    async UpdateDocumentJSON({ _, commit }: any, id: any | null = null) {
        let datos
        if (id) {
            await directusApi('GET', `items/ai_assistants/${id}`)
                .then(res => {
                    commit('SET_ACTIVE_CHATBOT_DOCUMENT', res.data.data);
                    console.log(res.data.data);
                    datos = res.data.data
                    return res.data.data;
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_CHATBOT_DOCUMENT', defaultChatbotDocument);
        }
        return datos;
    },

    /*#####################
    # Crear un asistente #
    ######################*/
    async postOne({ _, commit, dispatch }: any, data: any) {
        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', true);
        try {
            console.log(data.data.assistant_name);
            
            await directusApi('POST', `custom/ai-connection/create-asistant`,{name: data.data.assistant_name}).then(async res => {
                if(res.data.status == 200){
                    await directusApi('POST', 'items/ai_assistants', {
                        assistant_name: data.data.assistant_name,
                    }).then(async () => {
                        console.log(data);
                        
                        await directusApi('GET', `items/ai_assistants/${data.data.id}`)
                            .then(res => {
                                commit('SET_ACTIVE_CHATBOT_DOCUMENT', res.data.data);
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    });
                    data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                        title: `Obteniendo información`,
                        variant: 'success',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                    console.log(res);}
                else{
                    console.log(res.data.data.message);
                    data.vm.$bvToast.toast(`Ha ocurrido un error de sistema ${res.data.data.message}`, {
                        title: `Error de sistema`,
                        variant: 'danger',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                }
            });
            
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
            dispatch('getAll', { page: 1 });
            data.vm.$bvModal.hide('chatbot-documents-modal');
        }
    },

    /*#########################
    # Actualizar sku_documents#
    ###########################*/
    async UpdateSKUDocument({ _, commit, dispatch}: any, id: any){
        let datos = await directusApi('GET', `items/ai_assistants/${id}`)
        console.log(datos);
        
        return datos
    },

    /*###############################################
    # Obtener respuesta y resumen de la conversacion#
    #################################################*/
    async chatSummary({ _, commit, dispatch}: any, data: any){
            let datos
            if (data.id) {
                await directusApi('GET', `items/ai_assistants/${data.id}`)
                    .then(res => {
                        commit('SET_ACTIVE_CHATBOT_DOCUMENT', res.data.data);
                        console.log(res.data.data);
                        datos = res.data.data
                        return res.data.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
                    });
            } else {
                commit('SET_ACTIVE_CHATBOT_DOCUMENT', defaultChatbotDocument);
            }
            return datos;
        
    },

    /*######################################
    # Agregar un documento a un asistente#
    ###################################### */
    async putOneDocument({ _, commit, dispatch}: any, data: any) {
        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', true);
        let ChatbotEndpoint: string = 'items/ai_assistants';
        let ChatbotMethod: 'PATCH' | 'POST' = 'POST';
        let id_sku_document = 0;
        if (data.data.id && data.data.id != 0) {
            ChatbotMethod = 'PATCH';
            ChatbotEndpoint = `items/ai_assistants/${data.data.id}`;
        }
        // if(data.data.sku_document.lenght != null || data.data.sku_document.lenght != 0){
        //     id_sku_document = data.data.sku_document.lenght-1;
        // }
        try {
            // Enviar solicitud para crear o actualizar el agente sin sku_document inicialmente
            let assistant = await directusApi(ChatbotMethod, ChatbotEndpoint, {
                assistant_name: data.data.assistant_name,
            });
            let document: any = {};
            if (data.data.document) {
                console.log(data.data.document);
                if (data.data.document.origin === 'upload') {
                    let documentNameValidation = await validateFileName(data.data.document.name);
                    if (documentNameValidation === 0) {
                        let resFile = await directusApi('POST', `files`, data.data.document.file);
                        document = {
                            id: resFile.data.data.id,
                            sort: data.data.document.sort,
                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                            origin: 'directus',
                            name: resFile.data.data.title,
                            file: data.data.document.file,
                        };
                        console.log(data.data.id_document);
                        console.log( data.data.sku_document[id_sku_document].sku,);
                        
                        await directusApi('POST', `custom/ai-connection/documents`, {
                            id: data.data.id_document,
                            file: document,
                            table: data.data.assistant_name /*Aqui iria el nombre del asistente */,
                            id_product: data.data.sku_document[id_sku_document].sku,
                        }).then(async res => {
                            console.log(res);
                        });

                        // Actualizar sku_document solo después de subir correctamente el archivo
                        await directusApi(ChatbotMethod, ChatbotEndpoint, {
                            sku_document: data.data.sku_document,
                        })
                            .then(async (res: any) => {
                                dispatch('getOne', assistant.data.data.id);
                                data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                    title: `Obteniendo información`,
                                    variant: 'success',
                                    toaster: 'b-toaster-top-center',
                                    autoHideDelay: 5000,
                                });
                            })
                            .catch(err => {
                                console.log('Error al actualizar sku_document: ', err);
                            });
                    } else {
                        data.vm.$bvToast.toast(
                            `Error al guardar, el documento ${data.data.document.name} ya existe. Si quieres agregarlo a este asistente es necesario buscarlo desde existentes y volver a intentarlo`,
                            {
                                title: `Documento ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            }
                        );

                        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
                        // return false;
                    }
                } else if (data.data.document.origin === 'directus-update') {
                    console.log(data.data.document, origin);

                    await directusApi('GET', `files/${data.data.document.id}`).then(async (resFile: any) => {
                        document = resFile.data.data;
                    });
                    console.log(document.title);
                    console.log( data.data.sku_document[0].sku);
                    let url_document = {
                        url: `https://directus.prodelec.app/assets/${data.data.document.id}`,
                        name: document.title,
                    };
                    // console.log( data.data.sku_document[id_sku_document].sku);
                    await directusApi('POST', `custom/ai-connection/documents`, {
                        id: data.data.id_document,
                        file: url_document,
                        table: data.data.assistant_name /*Aqui iria el nombre del asistente */,
                        id_product: "hola",
                    }).then(async res => {
                        console.log(res);
                    });

                    await directusApi(ChatbotMethod, ChatbotEndpoint, {
                        sku_document: data.data.sku_document,
                    })
                        .then(async (res: any) => {
                            dispatch('getOne', assistant.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log('Error al actualizar sku_document: ', err);
                        });

                    // Lógica adicional para el caso de actualización de un documento desde Directus.
                }
            } else {
                data.vm.$bvToast.toast(`Error al actualizar asistente, no has agregado un documento para actualizar su información`, {
                    title: `No hay documento`,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            }

            commit('SET_ACTIVE_CHATBOT_DOCUMENT', assistant.data.data);
            dispatch('getOne', assistant.data.data.id);
            // dispatch('getAll');
            return await directusApi('GET', `items/ai_assistants/${data.data.id}`);
        } catch (err) {
            console.log('Error: ', err);
            data.vm.$bvToast.toast(`Ha ocurrido un error de sistema ${err}`, {
                title: `Error de sistema`,
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            // this.activeChatbotDocument.document = null;
            return await directusApi('GET', `items/ai_assistants/${data.data.id}`);
        } 
        finally {
            commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
        }
    },


    /*########################################
    # Eliminar un documento de un asistente#
    ########################################*/
    async deleteOneDocument({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', true);
        console.log(data.data.assistant_name);
        console.log(data.data.id_document);
        try {
            let res = await directusApi('DELETE', `custom/ai-connection/delete-document`, { table: data.data.assistant_name, id: data.data.id_document})
                console.log(res);
                    data.vm.$bvToast.toast('Se ha actualizado exitosamente', {
                        title: `asistente actualizado`,
                        variant: 'success',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                    await directusApi('PATCH', `items/ai_assistants/${data.data.id}`, {
                        assistant_name: data.data.assistant_name,
                        sku_document: data.data.sku_document,
                    })
                    commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
        } catch (error) {
            console.log(error);
            
            // console.log(res.data.data.message);
            data.vm.$bvToast.toast(`Ha ocurrido un error de sistema ${error}`, {
                title: `Error de sistema`,
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
    },

            
  /*###################################
    # Ver un documento de un asistente#
    ###################################*/
    async getInfo({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', true);
        try {
            console.log(data.data.id_document);
            console.log(data.data.assistant_name);
            let res = await directusApi('POST', `custom/ai-connection/get-document`, {
                table_name: data.data.assistant_name,
                id: data.data.id_document,
            })
            
                if (res.data.status == 200) {
                    console.log(res.data.data);
                    let content = res.data.data;
                    return content;
                }else{
                    
                }
            commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
            return res;

        } catch (error) {
            commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);
            console.log(error);
                    data.vm.$bvToast.toast(`Ha ocurrido un error de sistema ${error}`, {
                        title: `Error de sistema`,
                        variant: 'danger',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
        }
    },

  /*##########################
    # Eliminar a un asistente#
    ##########################*/
    async deleteOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ALL_CHATBOTS_LOADING', true);
        // commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', true);

        try {
            await directusApi('DELETE', `custom/ai-connection/delete-asistant`, { table_name: data.assistant_name })
            .then(async (res: any) => {
                await directusApi('DELETE', `items/ai_assistants/${data.id}`, {});
                data.vm.$bvToast.toast('Se ha eliminado exitosamente', {
                    title: `Asistente eliminado`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('TOGGLE_ALL_CHATBOTS_LOADING', false);
                commit('REMOVE_CHATBOT_DOCUMENT', data.id);
            })
        } catch (error) {
            commit('TOGGLE_ALL_CHATBOTS_LOADING', false);
            console.log(error);
                    data.vm.$bvToast.toast(`Ha ocurrido un error de sistema ${error}`, {
                        title: `Error de sistema`,
                        variant: 'danger',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
        }
        
            // .catch(err => {
            //     console.log(err);
            // })
            // .finally(() => {
            //     commit('TOGGLE_ALL_CHATBOTS_LOADING', false);
            //     // commit('TOGGLE_ACTIVE_CHATBOT_DOCUMENT_LOADING', false);

            //     // data.vm.$bvModal.hide(modalDelete-${data.id})
            // });
    },

  /*########################################
    # Respuesta de pregunta de un asistente#
    ######################################## */

    async getAnswer({ _, commit }: any, assistant: any) {
        
            let res = await directusApi(
                'GET',
                `custom/ai-connection/ask?question=${assistant.human}&assistant_name=${assistant.assistant_name}&token=${process.env.VUE_APP_TOKEN_API_BOT}`
            ) 
            console.log(res.data.status);
            if (res.data.status == 200) {
                console.log("Respuesta");
                console.log(res.data.data.message);
                return res.data.data.message
            } else {
                console.log(res.data.data.message);
                return `ERROR ${res.data.data.message}`
            }
            // console.log("Respuesta");
            // console.log(res.data.data.message);
            // return res.data.data.message
            
            // .then(async res => {
            //     console.log("status");
            //     console.log(res.data.status);
            //     console.log(res.data.data.message);
            //     return res.data.data.message
                // console.log(res.data.data.respuesta);
                // return res.data.data.respuesta;
                // if (res.data.status == 200) {
                //     console.log(res.data.data);
                //     let content = res.data.data;
                //     return content;
                // }else{
                //     console.log(res.data.data.message);
                //     data.vm.$bvToast.toast(Ha ocurrido un error de sistema ${res.data.data.message}, {
                //         title: Error de sistema,
                //         variant: 'danger',
                //         toaster: 'b-toaster-top-center',
                //         autoHideDelay: 5000,
                //     });
                // }
                
            // });  
    },
    async getAnswerSummary({ _, commit }: any, assistant: any) {
        try {
            let res; 
            console.log(assistant);
            if (assistant.summary) {
                console.log(1);
                res = await directusApi('GET', `custom/ai-connection/ask_summary?summary=${assistant.summary}&message=${assistant.human}&table_name=${assistant.assistant_name}`
                ) 
            } else {
                console.log(assistant.assistant_name);
                res = await directusApi('GET', `custom/ai-connection/ask_summary?message=${assistant.human}&table_name=${assistant.assistant_name}`
                ) 
            }
            if (res.status == 200) {
                console.log("Respuesta");
                return res.data
            } else {
                console.log(res.data.response);
                return `ERROR ${res.data.response}`
            }
        } catch (error) {
            console.log(error);
        }
},
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};